import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { getInsightText } from '../../lib/utils'
import { useStats } from '../../lib/ctx/stats'

export const ReaderSummaryText = ({
  color,
  text,
}: {
  color: string
  text: string
}) => {
  const isProfileView = useStats((s) => s.isProfileView)
  const { colors } = useTheme()
  const summaryText = getInsightText(text, colors.uiWhite)

  return (
    <Text
      className={css`
        font-weight: 600;
        line-height: 20px;
        padding: ${isProfileView ? '0 20px' : '0px'};
      `}
      type="body"
      sizing="L"
      align="center"
      color={color}
    >
      {summaryText}
    </Text>
  )
}
